export default "__VITE_ASSET__Dlx6eGVo__"